import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { saveAs } from "file-saver";

import { buildFixedColumns, buildAllDynamicColumns } from "./registryImportColumns";
import { buildRegistryTemplateWorkbook } from "./excelTemplateBuilder";

export default function GenerateRegistryTemplate() {
  const [generando, setGenerando] = useState(false);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventSubEventsRegistry = useSelector(
    (state) => state.events.eventSubEventsRegistry
  );
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );

  async function generar() {
    setGenerando(true);
    try {
      const columnasFijas = buildFixedColumns(registryConfiguration || {});
      const columnasDinamicas = buildAllDynamicColumns(registryConfiguration || {});

      const workbook = await buildRegistryTemplateWorkbook(
        eventDetail,
        eventSubEventsRegistry || {},
        registryConfiguration || {},
        columnasFijas,
        columnasDinamicas
      );
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const nombreArchivo = `plantilla-inscripciones-${
        (eventDetail && (eventDetail.nombreEvento || eventDetail.iDEvento)) ||
        "evento"
      }.xlsx`;
      saveAs(blob, nombreArchivo);
    } finally {
      setGenerando(false);
    }
  }

  return (
    <Button
      onClick={generar}
      variant="contained"
      style={{ padding: 10, width: 300, margin: 5 }}
      disabled={generando || !eventSubEventsRegistry || !registryConfiguration}
    >
      <i className="material-icons right">description</i>{" "}
      {generando ? "Generando..." : "Plantilla de importación (Excel)"}
    </Button>
  );
}
